import React from 'react'
import { Container } from './styles'
import { ModalInformations } from '../ModalInformations'

interface ModalItemSurgicalProcedureProps {
  tussId: string | number
  description: string
}

const ModalItemSurgicalProcedure = ({ tussId, description }: ModalItemSurgicalProcedureProps): JSX.Element => {
  return (
    <Container>
      <p className="description">{description}</p>
      <ModalInformations label="Código TUSS" value={tussId} />
    </Container>
  )
}

export { ModalItemSurgicalProcedure }
